import React from "react";
import { Link } from "react-router-dom";
import {
  FaShieldAlt,
  FaCarSide,
  FaConciergeBell,
  FaParking,
  FaFire,
  FaUserTie,
  FaUserShield,
  FaMapMarkerAlt,
  FaCamera,
  FaVideo,
  FaClipboardList,
  FaCogs,
  FaHeadset,
  FaBuilding,
  FaHome,
} from "react-icons/fa";
import { FaBuildingShield } from "react-icons/fa6";

const services = [
  {
    id: "commercial-security",
    title: "Commercial Security",
    icon: <FaBuildingShield size={40} className="text-red-800" />,
    description:
      "Expert security solutions for businesses, offices, and commercial properties to prevent risks and ensure safety.",
  },
  {
    id: "residential-security",
    title: "Residential Security",
    icon: <FaHome size={40} className="text-red-800" />,
    description:
      "Dedicated residential security services to protect homes, communities, and residents with vigilance and care.",
  },
  {
    id: "vip-security",
    title: "VIP Security",
    icon: <FaUserShield size={40} className="text-red-800" />,
    description:
      "Discreet and professional protection for high-profile individuals, ensuring safety with minimal disruption.",
  },
  {
    id: "condominium-security",
    title: "Condominium Security",
    icon: <FaBuildingShield size={40} className="text-red-800" />,
    description:
      "Specialized safety services for condominiums and apartments, balancing security with a welcoming atmosphere.",
  },
  {
    id: "uniformed-security",
    title: "Uniformed Security",
    icon: <FaShieldAlt size={40} className="text-red-800" />,
    description:
      "New Way Security provides highly trained, professional uniformed guards to protect properties and maintain a secure presence.",
  },
  {
    id: "mobile-security",
    title: "Mobile Security",
    icon: <FaShieldAlt size={40} className="text-red-800" />,
    description:
      "Our mobile patrol units offer rapid response and proactive site monitoring to deter threats across multiple locations.",
  },
  {
    id: "fire-watch-security",
    title: "Fire Watch Security",
    icon: <FaFire size={40} className="text-red-800" />,
    description:
      "Specialized fire watch officers ensure compliance and safety in areas at risk, protecting lives and property.",
  },
  {
    id: "concierge-security",
    title: "Concierge Security",
    icon: <FaConciergeBell size={40} className="text-red-800" />,
    description:
      "Blending hospitality with security, our concierge team manages access, assists residents, and enhances building safety.",
  },
  {
    id: "elite-suite-tie-security",
    title: "Elite Suit & Tie Security",
    icon: <FaUserTie size={40} className="text-red-800" />,
    description:
      "Discreet, professional security tailored for high-profile clients and luxury environments requiring a polished presence.",
  },
  {
    id: "executive-protection",
    title: "Executive Protection",
    icon: <FaUserShield size={40} className="text-red-800" />,
    description:
      "Personal protection specialists safeguard executives and VIPs with a discreet, proactive approach to risk management.",
  },
  {
    id: "gatehouse-security",
    title: "Gatehouse Security",
    icon: <FaMapMarkerAlt size={40} className="text-red-800" />,
    description:
      "Dedicated gatehouse officers provide access control, visitor verification, and perimeter monitoring for secure facilities.",
  },
  {
    id: "event-security",
    title: "Event Security",
    icon: <FaShieldAlt size={40} className="text-red-800" />,
    description:
      "Trained personnel manage safety and crowd control at corporate, private, and public events of any scale.",
  },
  {
    id: "camera-installations",
    title: "Camera Installations",
    icon: <FaCamera size={40} className="text-red-800" />,
    description:
      "State-of-the-art surveillance system installations designed to enhance property security and deter criminal activity.",
  },
  {
    id: "camera-monitoring",
    title: "Camera Monitoring",
    icon: <FaVideo size={40} className="text-red-800" />,
    description:
      "24/7 monitoring services ensure real-time oversight, quick incident response, and proactive threat management.",
  },
  {
    id: "loss-prevention",
    title: "Loss Prevention",
    icon: <FaClipboardList size={40} className="text-red-800" />,
    description:
      "Experienced security staff minimize theft, reduce shrinkage, and protect assets in retail and commercial settings.",
  },
  {
    id: "security-systems",
    title: "Security Systems",
    icon: <FaCogs size={40} className="text-red-800" />,
    description:
      "Advanced alarm, access control, and integrated system solutions tailored to safeguard people and property.",
  },
  {
    id: "consulting-services",
    title: "Consulting Services",
    icon: <FaHeadset size={40} className="text-red-800" />,
    description:
      "Expert security consulting helps businesses assess risks, develop strategies, and implement effective protection plans.",
  },
  {
  id: "tailored-services",
  title: "Tailored Services",
  icon: <FaCogs size={40} className="text-red-800" />,
  description:
    "Custom-designed security plans adapted to unique client needs, industries, and environments.",
},
];

const testimonials = [
  {
    name: "Sarah M.",
    role: "Event Manager",
    quote:
      "New Way Security’s team handled our event flawlessly. Guests felt safe, and their team was professional and calm throughout.",
  },
  {
    name: "Thomas L.",
    role: "Warehouse Owner",
    quote:
      "We’ve had zero incidents since hiring their mobile patrol units. Their presence alone prevents issues.",
  },
  {
    name: "Sarah M.",
    role: "Event Manager",
    quote:
      "New Way Security’s team handled our event flawlessly. Guests felt safe, and their team was professional and calm throughout.",
  },
  {
    name: "Thomas L.",
    role: "Warehouse Owner",
    quote:
      "We’ve had zero incidents since hiring their mobile patrol units. Their presence alone prevents issues.",
  },
];

const cases = [
  {
    title: "Before: Warehouse Theft Issues",
    before: "Frequent equipment losses and break-ins at night.",
    after:
      "New Way Security installed access control and scheduled mobile patrols. Losses dropped to zero in 3 months.",
  },
  {
    title: "Before: Chaotic Event Management",
    before: "Crowd control failures and guest complaints.",
    after:
      "With custom event security, traffic was managed smoothly and no incidents were reported.",
  },
  {
    title: "Before: Warehouse Theft Issues",
    before: "Frequent equipment losses and break-ins at night.",
    after:
      "New Way Security installed access control and scheduled mobile patrols. Losses dropped to zero in 3 months.",
  },
  {
    title: "Before: Chaotic Event Management",
    before: "Crowd control failures and guest complaints.",
    after:
      "With custom event security, traffic was managed smoothly and no incidents were reported.",
  },
];

const Services = () => {
  return (
    <div className="py-12 px-6 text-xl">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-red-800">
          Our Security Services
        </h1>
        <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
          Tailored, professional, and tech-enabled — we protect what matters
          most.
        </p>
      </div>

      <div className="grid grid-cols-1 text-xl sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto my-12">
        {services.map((service, index) => (
          <Link
            to={`/services/${service.id}`}
            key={index}
            className="bg-white border border-red-800 rounded-2xl p-6 shadow-md hover:shadow-xl transition-shadow duration-300 group block"
          >
            <div className="flex justify-center mb-4">{service.icon}</div>
            <h3 className="text-2xl font-semibold text-center text-red-800 mb-2 group-hover:underline">
              {service.title}
            </h3>
            <p className="text-gray-700 text-lg text-center">
              {service.description}
            </p>
          </Link>
        ))}
      </div>

      <div className="mb-20">
        <h2 className="text-3xl font-bold text-center text-red-800 mb-10">
          What Clients Say
        </h2>
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white p-6 rounded-xl shadow border-l-4 border-r-4 border-b-4 border-red-800"
            >
              <p className="text-gray-700 italic mb-4">“{t.quote}”</p>
              <h4 className="text-red-800 font-semibold">{t.name}</h4>
              <p className="text-sm text-gray-500">{t.role}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="">
        <h2 className="text-3xl font-bold text-center text-red-800 mb-10">
          Real Impact Cases
        </h2>
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {cases.map((c, i) => (
            <div
              key={i}
              className="bg-white p-6 rounded-xl shadow-md border border-red-800"
            >
              <h4 className="text-xl font-semibold text-red-800 mb-2">
                {c.title}
              </h4>
              <p className="text-sm mb-1 text-black">
                <span className="font-bold text-gray-700">Before:</span>{" "}
                {c.before}
              </p>
              <p className="text-sm text-black">
                <span className="font-bold text-gray-700">After:</span>{" "}
                {c.after}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
